namespace Ir.Components.Filters.MonthFilter {
    interface IMonthFilterViewModel {
        filter: Filter;
        selectBoxComponent: DevExpress.ui.dxSelectBox;
        selectBoxSettings: DevExpress.ui.dxSelectBox.Properties;
        nullButtonParams: Ir.Components.Filters.NullButton.INullButtonParams;
    }

    export function getViewModel(this: IMonthFilterViewModel, params: IFilterParameterVM) {
        let self = this;
        this.filter = params.filter;
        let months = moment.months();

        let dataSource = [];
        let i = irSettings.yearMonthStart;
        for (let month of months) {
            dataSource.push({ id: (i + 1).toString(), text: month });
            i++;
            if (i == 12) {
                i = 0;
            }
        }
        dataSource.sort((a, b) => a.id - b.id);
        this.filter.startDisplayCondition(dataSource.find(x => x.id == this.filter.startCondition())?.text ?? irSettings.nullText);

        this.selectBoxSettings = {
            dataSource: dataSource,
            disabled: ko.computed(function () {
                return self.filter.readOnly();
            }) as any,
            displayExpr: 'text',
            valueExpr: 'id',
            value: this.filter.startCondition,
            onInitialized(e) {
                self.selectBoxComponent = e.component;
            },
            onValueChanged(data) {
                if (data.value !== null && data.previousValue !== data.value) {
                    self.filter.startCondition(data.value);
                    self.filter.startDisplayCondition(dataSource.find(x => x.id == data.value).text);
                    self.filter.publish();
                }
            },
        };

        this.nullButtonParams = {
            filter: this.filter,
            onItemClick(e) {
                if (self.filter.startCondition() === null) {
                    let firstMonth = dataSource.length > 0 ? dataSource[0] : null;
                    self.filter.startCondition(firstMonth?.id ?? null);
                    self.filter.startDisplayCondition(firstMonth?.text ?? irSettings.nullText);
                }
                else {
                    self.filter.startCondition(null);
                    self.filter.startDisplayCondition(irSettings.nullText);
                }

                self.filter.publish();
                self.selectBoxComponent.element().focus();
            }
        };
    }
}